import { render, staticRenderFns } from "./StrTaskModelSelect.vue?vue&type=template&id=c5bf71fc&"
import script from "./StrTaskModelSelect.vue?vue&type=script&lang=js&"
export * from "./StrTaskModelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports